import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { userCreditErrorSelector } from '@hero/redux-data/backoffice/userCredit/selectors';
import { useNotifications } from '../../context/notification';
const useUserCreditFailAlert = () => {
    const { error, errorMessage } = useSelector(userCreditErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: errorMessage || 'Error fetching/saving credit.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, errorMessage]);
};
export default useUserCreditFailAlert;
